'use client'
import React, { useImperativeHandle, useRef } from 'react'
import type { WhyChooseProps, WhyChooseItem as ItemType } from './types.js'
import { Picture, Text } from '../../components/index.js'
import { cn } from '../../helpers/index.js'
// import { withStyles } from '../../shared/Styles.js'
import { withLayout } from '../../shared/Styles.js'
import SwiperBox from '../SwiperBox/index.js'

const WhyChoose = React.forwardRef<HTMLDivElement, WhyChooseProps>(({ data, className }, ref) => {
  const innerRef = useRef<HTMLDivElement>(null)
  useImperativeHandle(ref, () => innerRef.current!)

  return (
    <div ref={innerRef} className={cn(className)}>
      <SwiperBox
        className="!overflow-visible [&_.swiper-wrapper]:flex"
        data={{
          list: data?.productData || [],
          configuration: { shape: 'card', isTab: true },
        }}
        Slide={WhyChooseItem}
        breakpoints={{
          0: { slidesPerView: 1, spaceBetween: 12 },
          374: { slidesPerView: 1.2, spaceBetween: 12 },
          768: { slidesPerView: 2.3, spaceBetween: 16 },
          1025: { slidesPerView: 4, spaceBetween: 16 },
          1440: { slidesPerView: 4, spaceBetween: 16 },
          1920: { slidesPerView: 4, spaceBetween: 16 },
        }}
        id={''}
      />
    </div>
  )
})

WhyChoose.displayName = 'WhyChoose'

const WhyChooseItem = ({ data }: { data: ItemType }) => {
  return (
    <div className="whyChooseBlock laptop:p-[24px] laptop:shrink box-border w-full shrink-0 rounded-[16px] bg-[#EAEAEC] p-[16px]">
      <Picture source={data.img.url} className="w-[36px]" />
      <div className="mt-[16px]">
        <Text
          html={data?.title}
          className="line-clamp-2 overflow-hidden text-ellipsis text-[20px] font-bold leading-[1.2]"
        />
        <div className="mt-[8px]">
          <Text
            html={data?.desc}
            className="line-clamp-2 overflow-hidden text-ellipsis text-[14px] font-bold leading-[1.2]"
          />
        </div>
      </div>
    </div>
  )
}

WhyChooseItem.displayName = 'WhyChooseItem'

export default withLayout(WhyChoose)
export { WhyChooseItem }
